module.exports = __webpack_public_path__ + "ac28e20189bd39c12e6ffa29a7fb4303.png";